function searchOpen() {
  var open = document.querySelector(".live-search-scroll");
  if (open.style.display === "block") {
    open.style.display = "none";
  } else {
    open.style.display = "block";
  }
  var over = document.querySelector(".search-overlay");
        over.classList.add('search-opened');
  var bodyScroll = document.querySelector(".site-main");
        bodyScroll.classList.add('search-opened');
}

function searchClose() {
  var close = document.querySelector(".live-search-scroll");
  if (close.style.display === "none") {
    close.style.display = "block";
  } else {
    close.style.display = "none";
  }
   var over = document.querySelector(".search-overlay");
        over.classList.remove('search-opened');
   var bodyScroll = document.querySelector(".site-main");
        bodyScroll.classList.remove('search-opened');
}

function searchOpenMob() {
  var open = document.querySelector(".live-search");
  if (open.style.display === "block") {
    open.style.display = "none";
  } else {
    open.style.display = "block";
  }
  var over = document.querySelector(".search-overlay");
        over.classList.add('search-opened');
  var bodyScroll = document.querySelector(".site-main");
        bodyScroll.classList.add('search-opened');
}

function searchCloseMob() {
  var close = document.querySelector(".live-search");
  if (close.style.display === "none") {
    close.style.display = "block";
  } else {
    close.style.display = "none";
  }
   var over = document.querySelector(".search-overlay");
        over.classList.remove('search-opened');
   var bodyScroll = document.querySelector(".site-main");
        bodyScroll.classList.remove('search-opened');
}